import { render, staticRenderFns } from "./BoxElement.vue?vue&type=template&id=65caea49&scoped=true"
import script from "./BoxElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoxElement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BoxElement.vue?vue&type=style&index=0&id=65caea49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65caea49",
  null
  
)

export default component.exports